import 'slick-carousel'

jQuery('.slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    appendDots: '.slider-dots',
    prevArrow: '.arrow-prev',
    nextArrow: ".arrow-next"
  });